<template>
  <div class="bottom-carousel">
    <div class="carousel-top">
      <RouterLink
        target="_blank"
        :to="`/guide/guidelist?clID=${domainList?.clID}`"
      >
        <el-button>报考指南</el-button>
      </RouterLink>
      <RouterLink
        target="_blank"
        :to="`/examline/linelist?clID=${domainList?.clID}`"
      >
        <el-button>考试大纲</el-button>
      </RouterLink>
      <RouterLink
        target="_blank"
        :to="`/advice/advicelist?clID=${domainList?.clID}`"
      >
        <el-button>备考指南</el-button>
      </RouterLink>
    </div>
    <div class="carousel-bottom">
      <HitShow />
      <RouterLink target="_blank" to="/tests">
        <el-button>机考体验</el-button>
      </RouterLink>
      <RouterLink
        target="_blank"
        :to="`/video?firstCate=${domainList?.chID}&secondCate=${domainList?.coID}&thirdCate=${domainList?.clID}`"
      >
        <el-button>免费试听</el-button></RouterLink
      >
    </div>
  </div>
</template>

<script>
import HitShow from "./hit-show.vue";
export default {
  components: { HitShow },
  props: {
    domainList: {
      type: null,
      default: () => null,
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.bottom-carousel {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  height: 80px;
  width: 360px;

  .carousel-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    width: 360px;
  }
  .carousel-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    width: 360px;
  }
}
</style>
